import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';
import { FormConfig } from '../../definition/types/subscription';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        initialPaymentFeesPercent: [
          !_.isNil(entity?.parameters?.initialPaymentFeesPercent)
            ? entity?.parameters?.initialPaymentFeesPercent * 100
            : null,
          Validators.required,
        ],
        folderFeesAmount: [
          !_.isNil(entity?.parameters?.folderFeesAmount)
            ? entity?.parameters?.folderFeesAmount
            : null,
          Validators.required,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  floorValue(value: number) {
    return Math.floor(value * 100) / 100;
  }

  extract() {
    const formValue = _.cloneDeep(this.form?.value?.products);
    formValue?.forEach(item => {
      if (item?.parameters?.initialPaymentFeesPercent)
        item.parameters.initialPaymentFeesPercent =
          +item.parameters.initialPaymentFeesPercent / 100;
    });
    return formValue;
  }
}
